import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useLocStates = (country) => useQuery({ queryKey: ['states', country], queryFn: async () => {
    const callback = await API.get(`/common/loc/countries/${country}/states`)
    return callback?.data
}})

export default useLocStates